import { fetchAPI } from '@/services/prismic';
import { camelize } from '@/scripts/camelize';

export const getLocationByIdQuery = `
  query getLocationById($id: String!) {
    allLocations(uid: $id) {
      edges {
        node {
          meta_title
          meta_description
          city
          description
          call_to_actions {
            call_to_action {
              ... on Call_to_action {
                title
                type
                style
                url
                open_in_another_page
              }
            }
          }
          title
          location_name
          images {
            image
          }
          highlights {
            ... on Location_highlights {
              title
              location_founded
              location
              climate
              additional_information
              images {
                image
                image_url {
                  ... on _ExternalLink {
                    url
                    target
                  }
                }
              }
            }
          }
          location_details {
            detail {
              ... on Location_detail {
                title
                show_title
                details
                image
              }
            }
          }
          video {
            ... on Our_videos {
              title
              urls {
                video_url {
                  ... on _ExternalLink {
                    url
                    target
                  }
                }
              }
            }
          }
          perfect_locations {
            ... on Perfect_location {
              title
              sub_title
              locations {
                location {
                  ... on Location {
                    title
                    city
                    location_name
                    description
                    call_to_actions {
                      call_to_action {
                        ... on Call_to_action {
                          title
                          type
                          style
                          url
                          open_in_another_page
                        }
                      }
                    }
                    images {
                      image
                    }
                  }
                }
              }
            }
          }
          banner {
            ... on Banner {
             _meta {
               id
             }
             background_image
             items {
              item {
                ... on Banner_card {
                  title
                  buttons {
                    primary_button {
                      ... on Call_to_action {
                        title
                        type
                        style
                        url
                        open_in_another_page
                      }
                    }
                  }
                }
              }
            }
           }
         }
          top_programs_title
          programs {
            program {
              ... on Style_card {
                _meta {
                  tags
                }
                card_content {
                  ... on Styled_card_content {
                    title
                    summary
                  }
                }
                image
              }
            }
          }
          share_text
          photos_button_text
        }
      }
    }
  }
`;

export const fetchLocationContent = async (id = '', previewData) => {
  const {
    allLocations: {
      edges: [{
        node: locationContent = {},
      } = {}] = [],
    } = {},
  } = await fetchAPI(getLocationByIdQuery, {
    previewData,
    variables: {
      id,
    },
  });

  return camelize(locationContent);
};

export const getProgramsContent = content => {
  const topPrograms = JSON.parse(JSON.stringify(content));

  const programs = topPrograms.reduce(
    (accumulator, currentValue) => {
      const program = {
        ...currentValue.program,
      }
      
      const card = {
        card: {
          ...program,
          title: program.cardContent.title,
          description: program.cardContent.summary,
          status: program.meta.tags.find(tag => tag.toLowerCase().indexOf('new') !== -1),
        },
      };

      accumulator.push(card);

      return accumulator;
    },
    []
  );

  topPrograms.cards = [...programs];

  return topPrograms;
};

export const getPerfectLocationsContent = (content, name ) => {
  content.locations = content.locations.filter(function(value, index, arr){ 
    return value.location.city !== name;
  });
  
  const perfectLocations = JSON.parse(
    JSON.stringify(content)
  );

  const locations = perfectLocations.locations.reduce(
    (accumulator, currentValue) => {
      const location = {
        ...currentValue.location,
        title: `${currentValue?.location?.city} ${currentValue?.location?.locationName}`,
        image: currentValue?.location?.images[0].image,
      }
      
      const card = {
        card: {
          ...location,
        },
      };

      accumulator.push(card);

      return accumulator;
    },
    []
  );
  perfectLocations.cards = [...locations];

  return perfectLocations;
}